/** @format */

import React from 'react';
import giftpointIcon from '../../../../../images/img/giftpoint.svg';
import popularityIcon from '../../../../../images/img/popularityBlack.svg';
import wineIcon from '../../../../../images/img/glass.svg';
import { Trans } from 'react-i18next';
import { useProfileModal } from './useProfileModal';

const ProfileModal = () => {
	const {
		url,
		navbarData,
		amount,
		friendAmount,
		followingAmount,
		fanAmount,
		lngOpen,
		language,
		giftPoints,
		totalPoints,
		setLngOpen,
		logOut,
		setActiveTab,
		directoProfile,
		gotoOtherPage
	} = useProfileModal();
	const { popularity, nickname, age, city, jobTitle } =
		navbarData && navbarData.profile
			? navbarData.profile
			: { popularity: 0, nickname: '', age: 0, city: '', jobTitle: '' };
	return (
		<div
			className="has-text-centered"
			style={{
				margin: 'auto',
				width: 325
			}}>
			<div className="card has-text-centered">
				<button className="button is-fullwidth is-light  is-small">
					<span className="icon" style={{ marginLeft: 5, marginRight: 5 }}>
						<img src={popularityIcon} alt="" />
					</span>
					<span className="has-text-weight-bold">{popularity}</span>
					<span className="icon" style={{ marginLeft: 5, marginRight: 5 }}>
						<img src={wineIcon} alt="" />
					</span>
					<span className="has-text-weight-bold">{totalPoints}</span>
					<span className="icon" style={{ marginLeft: 5, marginRight: 5 }}>
						<img src={giftpointIcon} alt="" />
					</span>
					<span className="has-text-weight-bold">{giftPoints}</span>
				</button>
				<div
					className="card-content has-text-centered"
					style={{
						height: !lngOpen ? '' : '500px'
					}}>
					<div className="container is-fluid">
						<div className="columns is-centered">
							<div className="column is-12-tablet is-12-desktop is-12-widescreen is-12-mobile">
								<div className="columns has-text-centered is-multiline">
									<div className="column is-12">
										<figure
											className="image"
											style={{
												width: 75,
												height: 75,
												borderRadius: 50,
												margin: 'auto',
												backgroundSize: 'cover',
												backgroundPosition: 'center',
												backgroundImage: `url(${url})`
											}}
										/>
										<br />

										<div
											className="long-and-truncated"
											style={{
												width: 150,
												margin: 'auto'
											}}>
											<span
												className="has-text-weight-bold"
												style={{
													fontSize: 17
												}}>
												{nickname}
											</span>
										</div>

										<div
											className="columns is-variable is-0 is-mobile is-flex is-justify-content-center"
											style={{
												fontSize: 14
											}}>
											<div className="column is-narrow has-text-weight-bold">
												{city}
												<span className="icon">‧</span>
												{age}
											</div>

											<div className="column is-narrow has-text-weight-bold">
												<div className="flex-parent">
													<div
														className="profile-header-truncated"
														style={{ width: 'auto' }}>
														{jobTitle && (
															<>
																<span className="icon">‧</span>
																<span>{jobTitle}</span>
															</>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="container is-fluid">
						<button
							className="button is-rounded"
							style={{
								marginTop: 10,
								marginBottom: 10
							}}
							onClick={() => {
								directoProfile();
							}}>
							<Trans i18nKey="profile.checkInfo" />
						</button>

						<div
							className="columns is-mobile is-multiline is-variable"
							style={{ marginTop: 5 }}>
							<div
								className="column is-3 has-text-centered"
								style={{ margin: 'auto' }}>
								{amount}
								<br />
								<span className="has-text-centered" style={{ fontSize: 13 }}>
									<Trans i18nKey="profile.meetup" />
								</span>
							</div>
							<div className="column is-3">
								{friendAmount}
								<br />
								<span className="has-text-centered" style={{ fontSize: 13 }}>
									<Trans i18nKey="profile.friend" />
								</span>
							</div>
							<div className="column is-3">
								{fanAmount} <br />
								<span className="has-text-centered" style={{ fontSize: 13 }}>
									<Trans i18nKey="profile.follower" />
								</span>
							</div>
							<div className="column is-3">
								{followingAmount}
								<br />
								<span className="has-text-centered" style={{ fontSize: 13 }}>
									<Trans i18nKey="profile.follow" />
								</span>
							</div>
						</div>
					</div>
					<hr style={{ marginBottom: 5 }} />

					<div className="container is-fluid">
						<div className="columns is-centered">
							<div className="column is-12-tablet is-12-desktop is-12-widescreen is-12-mobile">
								<div className="columns has-text-centered">
									<div className="column is-12">
										<div
											style={{
												fontSize: 10,
												display: 'flex',
												whiteSpace: 'nowrap'
											}}>
											<div>
												<a
													href="https://www.104.com.tw/company/1a2x6bis2k"
													rel="noopener noreferrer"
													target="_blank">
													<Trans i18nKey="navbar.pages.aboutus" />
												</a>
											</div>
											|
											<div
												style={{ cursor: 'pointer' }}
												onClick={() => {
													gotoOtherPage('terms');
												}}>
												<Trans i18nKey="navbar.userTerms" />
											</div>
											|
											<div
												style={{ cursor: 'pointer' }}
												onClick={() => {
													gotoOtherPage('privacy');
												}}>
												<Trans i18nKey="navbar.privacyPolicy" />
											</div>
											|
											<div
												style={{ cursor: 'pointer' }}
												onClick={() => {
													gotoOtherPage('aboutus/QA');
												}}>
												<Trans i18nKey="navbar.qa" />
											</div>
										</div>
										<button
											style={{
												marginTop: 6,
												textDecoration: 'none'
											}}
											className="button is-white is-small"
											onClick={logOut}>
											<Trans i18nKey="navbar.signOut" />
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						className="dropdown is-right is-hoverable"
						style={{ marginTop: 5 }}>
						<div className="dropdown-trigger">
							<span
								onClick={() => {
									setLngOpen(!lngOpen);
								}}
								className="has-text-grey"
								style={{
									cursor: 'pointer',
									fontSize: 13
								}}>
								<Trans i18nKey="navbar.language" />：{language}
							</span>
						</div>
						<div
							style={{
								display: lngOpen ? 'block' : 'none',
								position: 'absolute',
								left: 0,
								bottom: 0
							}}
							className="dropdown-menu"
							id="dropdown-menu"
							role="menu">
							<div className="dropdown-content">
								<a href="#" className="dropdown-item" onClick={setActiveTab}>
									中文
								</a>
								<a href="#" className="dropdown-item" onClick={setActiveTab}>
									English
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ProfileModal);
